"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ViewDerivateCalendar = void 0;
const view_derivate_base_1 = require("./view_derivate_base");
class ViewDerivateCalendar extends view_derivate_base_1.ViewDerivateBase {
    constructor(state, datasheetId) {
        super(state, datasheetId);
        this.state = state;
        this.datasheetId = datasheetId;
    }
    getViewDerivation(view) {
        return super.getViewDerivation(view);
    }
}
exports.ViewDerivateCalendar = ViewDerivateCalendar;
//# sourceMappingURL=view_derivate_calendar.js.map